import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedApiService } from '../../../shared/service/util.service';
import { loginModel } from '../Model/login.model';

@Injectable({
  providedIn: 'root'
})
export class loginService {

  private endpoint2 = `Portal/User/GetCurrentUserWeb`
  private endpoint = `Account/Login`

  private SharedApiService = inject(SharedApiService)

  login(params: loginModel) {
    return this.SharedApiService.postData2<any>(this.endpoint, params)
  }

  GetCurrentUser() {
    return this.SharedApiService.getAll2(this.endpoint2)
  }

}
